import { Download } from "lucide-react";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { useState, useEffect, useRef, act } from "react";
import Cookies from "js-cookie";
import { redirectToLogin } from "../../utils/auth";
import { SimpleModal } from "../Shared/SimpleModal";
import { SwimlaneDiagram } from "../Shared/SwimlaneDiagram";

export const Tickets = ({
  tickets,
  setCount,
  requestOptions,
  ticketCategories = [],
  priorities,
  status,
  activeIndex,
  isPartner,
  username,
  isPMO,
  portal
}) => {
  const navigate = useNavigate();
    const ticketPath = (id) => `/Ticket/${id}`;
  // RCS Support view (portal=rcs) uses a trimmed, RCS-client-style table.
  const isRcs = portal === "rcs";
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedButton, setSelectedButton] = useState("allTickets");
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [filteredByStates, setFilteredByStates] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [jassoVerified, setJassoVerified] = useState(true);

  const [sliderStyle, setSliderStyle] = useState({});
  const myTicketsRef = useRef(null);
  const allTicketsRef = useRef(null);

  const [swimlaneOpen, setSwimlaneOpen] = useState(false);
  const [swimlaneTicket, setSwimlaneTicket] = useState(null);

  const [sortColumn, setSortColumn] = useState("createdAt"); // default sort
  const [sortDir, setSortDir] = useState("desc"); // newest first by default

  // const authToken = Cookies.get("authToken");
  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    const jassoVerified = localStorage.getItem("jassoVerified");
    setJassoVerified(jassoVerified);
  }, []);

  console.log(jassoVerified);

  const handleButtonClick = (button) => {
    setSelectedButton(button);
  };

  useEffect(() => {
    let tempTickets = tickets;

    if (selectedButton === "myRequests") {
      // "Assigned to Me" is turn-aware, matching the Assigned column display:
      // when a ticket is Need More Info (5) / Resolved (3) / Closed (4) it's the
      // creator's turn, so it shows for the creator; otherwise it shows for the
      // real assignee. The stored assignee is never mutated.
      tempTickets = tempTickets.filter((ticket) =>
        ticket.status == 5 || ticket.status == 3 || ticket.status == 4
          ? ticket.createdBy == username
          : ticket.assign == username,
      );
    } else if (selectedButton == "myRequests") {
      tempTickets = tempTickets.filter(
        (ticket) =>
          // ((ticket.status == 5 || ticket.status == 3) &&
          ticket.createdBy == username,
        // ) ||
        // ticket.assign == username
      );
    } else if (selectedButton == "collaborators") {
      tempTickets = tempTickets.filter((ticket) => {
        // Split the comma-separated list into an array
        const collaboratorsArray = ticket.collaborators
          .split(",")
          .map((email) => email.trim());
        // Check if the email exists in the array
        return collaboratorsArray.includes(username);
      });
    } else if (selectedButton == "myRaised") {
      tempTickets = tempTickets.filter(
        (ticket) =>
          // ((ticket.status == 5 || ticket.status == 3) &&
          ticket.createdBy == username,
        // ) ||
        // ticket.assign == username
      );
    } else if (selectedButton == "Collaborators") {
      tempTickets = tempTickets.filter((ticket) => {
        // Split the comma-separated list into an array
        const collaboratorsArray = ticket.collaborators
          .split(",")
          .map((email) => email.trim());
        // Check if the email exists in the array
        return collaboratorsArray.includes(username);
      });
    }

    if (searchQuery.trim() !== "") {
      const lowerCaseQuery = searchQuery.toLowerCase();
      // Matches the "Raised By" column label so it's searchable too.
      const raisedByLabel = (ticket) => (ticket.raisedBy === 0 ? "internal" : "external");

      if (lowerCaseQuery.includes(" and ")) {
        // Use .every() for "AND" condition
        const queries = lowerCaseQuery.split(" and ");
        tempTickets = tempTickets.filter((ticket) =>
          queries.every(
            (query) =>
              ticket.ticketId.toLowerCase().includes(query) ||
              getServiceRequest(ticket.requestType)
                .toLowerCase()
                .includes(query) ||
              getPriority(ticket.priority).toLowerCase().includes(query) ||
              getStatus(ticket.status).toLowerCase().includes(query) ||
              getAssignedUser(ticket.assign).toLowerCase().includes(query) ||
              raisedByLabel(ticket).includes(query) ||
              ticket.updatedAt.toLowerCase().includes(query),
          ),
        );
      } else if (lowerCaseQuery.includes(" or ")) {
        // Use .some() for "OR" condition
        const queries = lowerCaseQuery.split(" or ");
        tempTickets = tempTickets.filter((ticket) =>
          queries.some(
            (query) =>
              ticket.ticketId.toLowerCase().includes(query) ||
              getServiceRequest(ticket.requestType)
                .toLowerCase()
                .includes(query) ||
              getPriority(ticket.priority).toLowerCase().includes(query) ||
              getStatus(ticket.status).toLowerCase().includes(query) ||
              getAssignedUser(ticket.assign).toLowerCase().includes(query) ||
              raisedByLabel(ticket).includes(query) ||
              ticket.updatedAt.toLowerCase().includes(query),
          ),
        );
      } else {
        // Normal search (single query)
        tempTickets = tempTickets.filter(
          (ticket) =>
            ticket.ticketId.toLowerCase().includes(lowerCaseQuery) ||
            getServiceRequest(ticket.requestType)
              .toLowerCase()
              .includes(lowerCaseQuery) ||
            getPriority(ticket.priority)
              .toLowerCase()
              .includes(lowerCaseQuery) ||
            getStatus(ticket.status).toLowerCase().includes(lowerCaseQuery) ||
            getAssignedUser(ticket.assign)
              .toLowerCase()
              .includes(lowerCaseQuery) ||
            raisedByLabel(ticket).includes(lowerCaseQuery) ||
            ticket.updatedAt.toLowerCase().includes(lowerCaseQuery),
        );
      }
    }
    setFilteredTickets(tempTickets);
  }, [selectedButton, searchQuery, tickets]);

  useEffect(() => {
    const temCount = { total: filteredTickets.length };
    (status ?? []).forEach((s) => {
      const vals = [String(s.value), ...(s.aliases ?? []).map(String)];
      temCount[s.value] = filteredTickets.filter((t) =>
        vals.includes(String(t.status)),
      ).length;
    });
    setCount(temCount);
  }, [filteredTickets, status]);

  useEffect(() => {
    if (activeIndex === "total") {
      setFilteredByStates(filteredTickets);
      return;
    }
    const statusObj = (status ?? []).find((s) => s.value === activeIndex);
    const vals = statusObj
      ? [String(statusObj.value), ...(statusObj.aliases ?? []).map(String)]
      : [String(activeIndex)];
    setFilteredByStates(
      filteredTickets.filter((t) => vals.includes(String(t.status))),
    );
  }, [filteredTickets, activeIndex, tickets, status]);

  function getAssignedUser(username) {
    if (isPartner) {
      return "JBM Customer Experience";
    }
    return username;
  }

  // Assigned-column display. The stored assignee never changes on status
  // transitions — so when a ticket is Need More Info (5), Resolved (3) or
  // Closed (4) it's the creator's turn and we DISPLAY the creator as the assignee
  // (without mutating the record). For clients (partners) the internal assignee is
  // otherwise masked as "JBM Customer Experience".
  const assigneeLabel = (ticket) => {
    const waiting = ticket.status == 5 || ticket.status == 3 || ticket.status == 4;
    if (waiting) return ticket.createdBy;
    return isPartner ? "JBM Customer Experience" : ticket.assign;
  };

  // Comparable value per sortable column. String columns sort case-insensitively;
  // date/number columns sort numerically. getServiceRequest/getPriority/getStatus
  // can throw on unknown codes, so they're guarded.
  const sortValue = (t) => {
    const safe = (fn, v) => {
      try { return fn(v); } catch { return ""; }
    };
    switch (sortColumn) {
      case "requestType": return safe(getServiceRequest, t.requestType).toLowerCase();
      case "priority": return Number(t.priority);
      case "deadline": return new Date(t.deadline).getTime() || 0;
      case "status": return Number(t.status);
      case "org": return (t.org || "").toLowerCase();
      case "assign": return (assigneeLabel(t) || "").toLowerCase();
      case "raisedBy": return Number.isFinite(Number(t.raisedBy)) ? Number(t.raisedBy) : 999;
      case "updatedAt": return new Date(t.updatedAt).getTime() || 0;
      case "createdAt":
      default: return new Date(t.createdAt).getTime() || 0;
    }
  };
  const sortedTickets = [...filteredByStates].sort((a, b) => {
    const va = sortValue(a);
    const vb = sortValue(b);
    const cmp =
      typeof va === "number" && typeof vb === "number"
        ? va - vb
        : String(va).localeCompare(String(vb));
    return sortDir === "asc" ? cmp : -cmp;
  });

  const toggleSort = (key) => {
    if (sortColumn === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortColumn(key);
      setSortDir("asc");
    }
  };
  const sortableTh = (label, key) => (
    <th
      onClick={() => toggleSort(key)}
      className="p-4 text-xs uppercase text-gray-500 border-b border-gray-200 cursor-pointer select-none hover:bg-gray-100 transition-colors whitespace-nowrap"
    >
      <span className="inline-flex items-center gap-1">
        {label}
        <span className="text-jiojbm50">
          {sortColumn === key ? (sortDir === "asc" ? "↑" : "↓") : ""}
        </span>
      </span>
    </th>
  );

  const totalPages = Math.max(
    1,
    Math.ceil(filteredByStates.length / itemsPerPage),
  );
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTickets = sortedTickets.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );

  function getServiceRequest(serviceId) {
    return requestOptions.find(
      (requestOption) => requestOption.value == serviceId,
    ).key;
  }

  // JBM "Ticket Type" (Task/Issue): the request type carries a category number
  // that maps to a ticket-category name. Empty if unmapped ("other").
  function getTicketType(t) {
    const opt = requestOptions.find((o) => o.value == t.requestType);
    if (!opt || opt.category === undefined || opt.category === null) return "";
    const cat = ticketCategories.find((c) => c.key === Number(opt.category));
    return cat ? cat.value : "";
  }

  function getPriority(priorityId) {
    return priorities.find((priority) => priority.value == priorityId).key;
  }

  function getStatus(statusId) {
    return status.find((stat) => stat.value == statusId).key;
  }

  useEffect(() => {
    setCurrentPage(1);
  }, [filteredByStates]);
  function getDeadlineCrossed(deadline) {
    const deadlineDate = new Date(deadline);

    // Make deadline 11:59:59.999 PM
    deadlineDate.setHours(23, 59, 59, 999);

    return new Date() > deadlineDate ? "Crossed" : "On Time";
  }

  function downLoadTickets() {
    // Export the currently filtered tickets (button + search + status-tab filters
    // applied, pagination ignored) straight from the on-screen data — no API call.
    // Full ticket detail, written as a real .xlsx via SheetJS.
    const rows = filteredByStates;
    if (!rows.length) {
      alert("No tickets to download for the current filters.");
      return;
    }

    const safe = (fn, v) => {
      try { return fn(v); } catch { return ""; }
    };
    const dOnly = (v) => (v ? new Date(v).toLocaleDateString() : "");
    const dTime = (v) => (v ? new Date(v).toLocaleString() : "");

    const columns = [
      { header: "Ticket ID", value: (t) => t.ticketId },
      { header: "Title", value: (t) => t.title || "" },
      { header: "Description", value: (t) => t.description || "" },
      ...(!isRcs
        ? [
            { header: "Service Request Type", value: (t) => safe(getServiceRequest, t.requestType) },
            { header: "Ticket Type", value: (t) => getTicketType(t) },
          ]
        : [{ header: "Issue At", value: (t) => t.issueAt || "" }]),
      { header: isRcs ? "Severity" : "Priority", value: (t) => safe(getPriority, t.priority) },
      { header: "Status", value: (t) => safe(getStatus, t.status) },
      ...(!isPartner
        ? [
            { header: "Deadline", value: (t) => (isRcs ? dTime(t.deadline) : dOnly(t.deadline)) },
            { header: "Deadline Status", value: (t) => getDeadlineCrossed(t.deadline) },
          ]
        : []),
      { header: "Assigned User", value: (t) => assigneeLabel(t) },
      ...(!isPartner ? [{ header: "Raised By", value: (t) => (t.raisedBy === 0 ? "Internal" : "External") }] : []),
      ...(!isPartner && !isRcs ? [{ header: "Organization", value: (t) => t.org || "" }] : []),
      ...(!isPartner
        ? [
            { header: "Created By", value: (t) => t.createdBy || "" },
            { header: "Collaborators", value: (t) => t.collaborators || "" },
          ]
        : []),
      ...(!isPartner && isRcs
        ? [{ header: "External Collaborators", value: (t) => t.externalCollaborators || "" }]
        : []),
      { header: "Resolution", value: (t) => t.resolution || "" },
      { header: "Created Date", value: (t) => dOnly(t.createdAt) },
      { header: "Last Updated", value: (t) => dOnly(t.updatedAt) },
    ];

    const header = columns.map((c) => c.header);
    const data = rows.map((t) =>
      Object.fromEntries(columns.map((c) => [c.header, c.value(t)])),
    );
    const ws = XLSX.utils.json_to_sheet(data, { header });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tickets");
    XLSX.writeFile(wb, "tickets.xlsx");
  }

  function openSwimlane(t) {
    fetch(
      `${process.env.REACT_APP_BACKEND_URL}/API/V2/Tickets/${t.ticketId}/history`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      },
    )
      .then((res) => {
        if (res.status === 401) return null;
        return res.json();
      })
      .then((data) => {
        if (!data) return;
        setSwimlaneTicket({
          id: t.ticketId,
          currentStage: getStatus(t.status),
          team: t.org || "Default",
          assign: t.assign,
          created: t.createdBy,
          createdDate: t.createdAt,
          history: Array.isArray(data) ? data : [],
        });
        setSwimlaneOpen(true);
      })
      .catch((err) => console.error("Swimlane fetch error:", err));
  }

  return (
    <div className="flex flex-col gap-2 rounded-3xl">
      <div className="flex gap-1 mb-0 items-center justify-center">
        <p className="mr-auto text-lg font-bold">Tickets</p>
      </div>

      <div className="flex items-center mb-2 mt-2">
        <div className="flex gap-1 ml-2 bg-jiojbm20 w-fit rounded-full p-1">
          <button
            className={`flex items-center justify-center gap-2 px-4 py-2 text-xs font-bold rounded-full transition whitespace-nowrap ${
              selectedButton === "allTickets"
                ? "bg-jiojbm50 text-white"
                : "text-gray-600 hover:bg-white/60"
            }`}
            onClick={() => handleButtonClick("allTickets")}
          >
            All Tickets
          </button>

          <button
            className={`flex items-center justify-center gap-2 px-4 py-2 text-xs font-bold rounded-full transition whitespace-nowrap ${
              selectedButton === "myRaised"
                ? "bg-jiojbm50 text-white"
                : "text-gray-600 hover:bg-white/60"
            }`}
            onClick={() => handleButtonClick("myRaised")}
          >
            Raised by Me
          </button>

          <button
            className={`flex items-center justify-center gap-2 px-4 py-2 text-xs font-bold rounded-full transition whitespace-nowrap ${
              selectedButton === "myRequests"
                ? "bg-jiojbm50 text-white"
                : "text-gray-600 hover:bg-white/60"
            }`}
            onClick={() => handleButtonClick("myRequests")}
          >
            Assigned to Me
          </button>
          <button
            className={`flex items-center justify-center gap-2 px-4 py-2 text-xs font-bold rounded-full transition whitespace-nowrap ${
              selectedButton === "Collaborators"
                ? "bg-jiojbm50 text-white"
                : "text-gray-600 hover:bg-white/60"
            }`}
            onClick={() => handleButtonClick("Collaborators")}
          >
            Collaborating On
          </button>
        </div>

        <div className="flex w-full justify-end">
          <div className="ml-4 flex items-center bg-white w-1/2 h-fit rounded-lg border border-gray-300 focus-within:border-jiojbm50 focus-within:ring-1 focus-within:ring-jiojbm50 py-1.5">
            <span className="w-5 h-5 fill-gray-400 ml-3 mr-1">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
              </svg>
            </span>
            <input
              className="w-full px-1 text-sm text-gray-700 leading-tight tracking-tight focus:outline-none"
              type="text"
              placeholder="Search by any field"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div className="relative group fill-gray-400 mr-3">
              <svg
                className="w-5 h-5"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 3.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 12h-4a1 1 0 010-2h1v-3h-1a1 1 0 010-2h2a1 1 0 011 1v4h1a1 1 0 010 2z"
                  fill=""
                ></path>
              </svg>
              <div className="absolute hidden group-hover:flex right-1 z-10 top-6 p-2 shadow-[0_0_16px_rgba(0,0,0,0.16)] bg-white rounded-lg text-sm font-medium w-60">
                Separate search terms with "and" to find results containing both
                terms and "or" to find results containing at least one.
              </div>
            </div>
          </div>

          <div className="flex gap-2 ml-2 mr-2 w-fit">
            {jassoVerified === "true" && (
              <button
                className="flex items-center gap-2 bg-jiojbm50 hover:bg-jiojbm60 px-4 text-xs font-bold tracking-tight leading-tight py-2 text-white rounded-3xl transition whitespace-nowrap"
                onClick={() => navigate("/Form")}
              >
                + Raise Ticket
              </button>
            )}

            {!isPartner && (
              <button
                className="flex items-center gap-2 border border-jiojbm50 text-jiojbm50 hover:bg-jiojbm20 px-4 text-xs font-bold tracking-tight leading-tight py-2 rounded-3xl transition whitespace-nowrap"
                onClick={() => downLoadTickets()}
              >
                <Download size={14} />
                Download Tickets
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="overflow-auto bg-white rounded-xl shadow-[0_2px_8px_rgba(0,0,0,0.05)] m-2">
        <table className="min-w-full text-left">
          <thead>
            <tr className="bg-gray-50">
              <th className="p-4 text-xs uppercase text-gray-500 border-b border-gray-200">
                Ticket ID
              </th>
              {sortableTh("Last Updated", "updatedAt")}
              {sortableTh("Service Request Type", "requestType")}
              {sortableTh("Priority", "priority")}
              {!isPartner && sortableTh("Deadline", "deadline")}

              {sortableTh("Status", "status")}
              {!isPartner && !isRcs && sortableTh("Organization", "org")}

              {sortableTh("Assigned User", "assign")}
              {!isPartner && sortableTh("Raised By", "raisedBy")}
              {sortableTh("Created Date", "createdAt")}
            </tr>
          </thead>
          <tbody>
            {currentTickets.map((ticket, index) => (
              <tr
                key={ticket._id}
                onDoubleClick={() => navigate(`/Ticket/${ticket.ticketId}`)}
                className="cursor-pointer border-t hover:bg-gray-50"
              >
                <td className="p-4 text-sm">
                  <div className="flex items-center gap-1.5">
                    <button
                      onClick={() => navigate(`/Ticket/${ticket.ticketId}`)}
                      className="font-bold text-jiojbm50 hover:underline"
                    >
                      {ticket.ticketId}
                    </button>
                    {!isPartner && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          openSwimlane(ticket);
                        }}
                        className="inline-flex items-center justify-center w-5 h-5 rounded hover:bg-gray-100 text-gray-400 hover:text-jiojbm60 transition"
                        title="View Swimlane"
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z" />
                        </svg>
                      </button>
                    )}
                  </div>
                </td>
                <td className="p-4 text-sm">
                  {ticket.updatedAt.slice(0, 10)}
                </td>
                <td className="p-4 text-sm">
                  {getServiceRequest(ticket.requestType)}
                </td>
                <td className="p-4 text-sm">{getPriority(ticket.priority)}</td>
                {!isPartner && (
                  <td className="p-4 text-sm">
                    {getDeadlineCrossed(ticket.deadline)}
                  </td>
                )}
                <td className="p-4 text-sm">
                  {getStatus(ticket.status)}
                </td>
                {!isPartner && !isRcs && (
                  <td className="p-4 text-sm">{ticket.org}</td>
                )}
                
                  <td className="p-4 text-sm">
                    {assigneeLabel(ticket)}
                  </td>
                {!isPartner && (
                  <td className="p-4 text-sm">
                    {ticket.raisedBy === 0 ? "Internal" : "External"}
                  </td>
                )}

                <td className="p-4 text-sm">
                  {ticket.createdAt.slice(0, 10)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex justify-between items-center w-full px-2">
        {/* Pagination Controls */}
        <div className="flex-1 flex gap-16 pl-32 justify-center items-center">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className={`w-10 h-10 flex items-center justify-center rounded-full ${
              currentPage === 1
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-gray-200"
            }`}
          >
            <div
              className={`relative flex items-center justify-center w-10 h-10 rounded-full cursor-pointer
        ${
          currentPage === 1 ? "fill-gray60" : "fill-jiojbm50 hover:bg-jiojbm20"
        }`}
            >
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
              >
                <path d="M14 17a1.003 1.003 0 01-.71-.29l-4-4a1 1 0 010-1.42l4-4a1.005 1.005 0 011.42 1.42L11.41 12l3.3 3.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z"></path>
              </svg>
            </div>
          </button>

          <p className="text-gray-700">
            Page {currentPage} of {totalPages}
          </p>

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className={`w-10 h-10 flex items-center justify-center rounded-full ${
              currentPage === totalPages
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-gray-200"
            }`}
          >
            <div
              className={`relative flex items-center justify-center rotate-180 w-10 h-10 rounded-full cursor-pointer
        ${
          currentPage === totalPages
            ? "fill-gray60"
            : "fill-jiojbm50 hover:bg-jiojbm20"
        }`}
            >
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
              >
                <path d="M14 17a1.003 1.003 0 01-.71-.29l-4-4a1 1 0 010-1.42l4-4a1.005 1.005 0 011.42 1.42L11.41 12l3.3 3.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z"></path>
              </svg>
            </div>
          </button>
        </div>

        {/* Select Dropdown at End */}
        <div className="ml-auto flex gap-x-2 items-center">
          <p className="font-bold text-jiojbmpurple tracking-tight leading-tight text-sm whitespace-nowrap">
            Tickets Per Page
          </p>
          <select
            className="border border-gray-300 rounded-full px-3 py-1"
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(e.target.value)}
          >
            {Array.from({ length: 10 }, (_, i) => (
              <option key={i} value={5 + i * 5}>
                {5 + i * 5}
              </option>
            ))}
          </select>
        </div>
      </div>

      <SimpleModal
        open={swimlaneOpen}
        title={
          swimlaneTicket ? `Swimlane \u2014 ${swimlaneTicket.id}` : "Swimlane"
        }
        onClose={() => setSwimlaneOpen(false)}
        maxWidth="max-w-6xl"
        heightClass="max-h-[85vh]"
      >
        {swimlaneTicket && <SwimlaneDiagram ticket={swimlaneTicket} />}
      </SimpleModal>
    </div>
  );
};
